module.exports = __webpack_public_path__ + "img/kp-l25.prt.21a21d1a.jpg";